const loadingLabel = "Loading";
const enUS = {
  loadingLabel
};
export {
  enUS as default,
  loadingLabel
};
